export function nameSeperate(fullname) {
  const nameArray = (fullname.trim()).split(" ");
  let finalName = "";
  let lastName = nameArray.pop();

  finalName += "<div>" + nameArray.join(" ") + '</div><div style="font-weight:700; font-size: 1rem;">' + lastName + "</div>";
  return finalName;
}

export function searchTable(el, cat) {
  // Declare variables
  var input, filter, table, tr, td, i, txtValue;
  input = el;
  filter = input.value.toUpperCase();
  table = document.getElementById("table_" + cat);
  tr = table.getElementsByTagName("tr");

  // Loop through all table rows, and hide those that don't match the search query
  for (i = 0; i < tr.length; i++) {
    td = tr[i].getElementsByTagName("td")[0];
    if (td) {
      txtValue = td.textContent || td.innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        tr[i].style.display = "";
      } else {
        tr[i].style.display = "none";
      }
    }
  }
}